import { gql } from "@apollo/client";

export const DeleteRectangleBannerWide = gql`
mutation DeleteRectangleBannerWide($deleteRectangleBannerWideId: ID!) {
  deleteRectangleBannerWide(id: $deleteRectangleBannerWideId) {
    status
  }
}
`;
